import { render, staticRenderFns } from "./CookiePrompt.vue?vue&type=template&id=75d2e18f&"
import script from "./CookiePrompt.vue?vue&type=script&lang=ts&"
export * from "./CookiePrompt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports